var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanasta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -2.51 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M214.973,826.978l-1.594,6.42c-.7,1.993-1.188,2.6-2.656,2.6h-8.5c-1.467,0-2.05-.463-2.656-2.6l-1.594-6.42h3.152l0,0,2.85-2.947h5l2.85,2.947,0,0ZM200.63,833.43a1.677,1.677,0,0,0,1.594,1.561h8.5c.88,0,1.382-.605,1.594-1.561l1.295-5.443H199.335Zm7.742-8.425h-3.8l-1.951,1.973h7.7Zm.6,4.995h1v2.969h-1Zm-3,0h1v2.978h-1Zm-3,0h1v2.978h-1Z",
    transform: "translate(-197.973 -824.029)",
    fill: "#444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanasta);
export default __webpack_public_path__ + "static/media/canasta.b7d4d3888c020d4fcfce4a3ed73efdf8.svg";
export { ForwardRef as ReactComponent };